import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useContext, useEffect, useState } from "react";
import { theme } from "../../styles/theme";
import { font } from "../../styles/font";

import { ApplicationContext } from "../../context/application_ctx";
import { HttpStatusCode } from "axios";
import { GlobalSnackBar } from "../../components/snackBar";
import { ButtonCustom } from "../../components/button";
import { getUploadCVS } from "../../api/controllers/registeredUserController";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import RegisterEmployeeDialog from "../../components/dialog/registerEmployeeDialog";
import { UserProfile } from "../userOnBoarding";
import { LicenseIcon } from "../../svgIcons/icons";
import { Audit } from "../audit";
import AssessmentIcon from "@mui/icons-material/Assessment";
import PaymentIcon from "@mui/icons-material/Payment";
import { PaymentDetails } from "../paymentDetails";
export const OrganisationDashboard = ({ admin,handleDiscountModal,detailsDialog,handleLicenceModal }) => {
  // context
  const {
    profileDetails,
    employeesList,
    setActiveTab,
    setGlobalLoader,
    licenceBatchList,
    setIsOpenRegisterEmployeeDialog,
    tableView,
    setTableView,
    setHeader,
    setLicenceType,
    paymentList,
  } = useContext(ApplicationContext);

  const navigate = useNavigate();
  const [profileSnack, setProfileSnack] = useState(false);
  // const [tableView, setTableView] = useState(0);
  const [error, setError] = useState("");
  const [reloadEmployees] = useState(false);

  const cardFilter = {
    all: "",
    allocated: "allocated",
    unallocated: "unallocated",
  };

  const [currentLicenceFilter] = useState(cardFilter.all);
  const [filteredList, setFilteredList] = useState(employeesList);
  console.log(filteredList, "filteredList");

  console.log(currentLicenceFilter, "currentLicenceFilter");
  let demoDateExpiration = dayjs(licenceBatchList[0]?.expirationDate)?.format(
    "YYYY-MM-DD"
  );
  let demoDatePurchase = dayjs(new Date()).format("YYYY-MM-DD");
  let finalDateDemo = dayjs(demoDateExpiration)?.diff(
    dayjs(demoDatePurchase),
    "days"
  );

  let standardDateExpiration = dayjs(
    licenceBatchList[licenceBatchList?.length - 1]?.expirationDate
  ).format("YYYY-MM-DD");
  let standardDatePurchase = dayjs(new Date())?.format("YYYY-MM-DD");
  let finalDateStandard = dayjs(standardDateExpiration)?.diff(
    dayjs(standardDatePurchase),
    "days"
  );
  console.log(finalDateDemo, finalDateStandard, "datefinal");

  console.log(profileDetails, "getderails");

  // const handleClose = () => {
  //   setSubDialog(false);
  //   setSubscriptionNav(false);
  // };

  useEffect(() => {
    let array = [...employeesList];

    // array = array.filter((data, index) => currentLicenceFilter ? data.licenseStatus === currentLicenceFilter : data)

    array = array.filter((data, index) =>
      currentLicenceFilter
        ? currentLicenceFilter === "allocated"
          ? data.isActive === true
          : data.isActive === false
        : data
    );

    console.log(array, "array");

    setFilteredList(array);
  }, [currentLicenceFilter]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    //setGlobalLoader(true);
    const getEmployees = async () => {
      try {
        let response = await getUploadCVS();
        console.log(response, "getEmployees");
        if (response.status === HttpStatusCode.Ok) {
          setTimeout(() => {
            setGlobalLoader(false);
          }, 2000);
          // setEmployeesList(response.data);
          // setFilteredList(response.data);
        }
        if (response.status === HttpStatusCode.Unauthorized) {
          navigate("/signin");
        }
        // setEmployeesData(response.data);
      } catch (error) {
        console.log(error);
      }
    };

    // const batches = async () => {
    //   try {
    //     let response = await getLicencBatch();
    //     console.log(response, "getEmployees");
    //     if (response.status === HttpStatusCode.Ok) {
    //       setTimeout(() => {
    //         setGlobalLoader(false);
    //       }, 2000);
    //       // setEmployeesList(response.data);
    //       // setFilteredList(response.data);
    //       setLicenceBatchList(response.data);
    //     }
    //     if (response.status === HttpStatusCode.Unauthorized) {
    //       navigate("/signin");
    //     }
    //     // setEmployeesData(response.data);
    //   } catch (error) {
    //     console.log(error);
    //   }
    // };
    // batches();
    if (!admin) {
      getEmployees();
    }
    // getRevokedEmployee();
  }, [reloadEmployees]); // eslint-disable-line react-hooks/exhaustive-deps
  let licenceDetails = [
    {
      label: "Total Licence",
      count:
        licenceBatchList
          ?.map((data) => data?.totalLicenses)
          ?.reduce((a, b) => a + b, 0) ?? 0,
    },
    { label: "Trial Licence", count: licenceBatchList[0]?.totalLicenses },
    {
      label: "Standard Licence",
      count:
        licenceBatchList
          ?.slice(1)
          ?.map((data) => data?.totalLicenses)
          ?.reduce((a, b) => a + b, 0) ?? 0,
    },
  ];
  let reloadEmployee = [...employeesList];
  console.log(reloadEmployee, "reload");

  const handleAccord = (type) => {
    setGlobalLoader(true);
    setHeader(type);
    setTimeout(() => {
      setGlobalLoader(false);
    }, 500);
    setActiveTab(1);
    if (!admin) {
      navigate("/employee-onboarding");
    }
  };

  console.log(filteredList, "afterfilter");
  // console.log(paymentList?.slice(1)?.map((data)=>parseFloat(data?.paymentAmount)),'check')

  return (
    <>
      <Box
        display="flex"
        width="100%"
        // height="100%"
        flexDirection="column"
        gap={tableView ? 0 : 4}
        position="relative"
        flex="1"
      >
        {/* count card */}
        {tableView !== 0 ? (
          <DashBoardNav setTableView={setTableView} tableView={tableView} />
        ) : (
          <>
            <Box display="flex" width="100%" flexWrap="wrap" gap="24px">
              <Box
                flex="1"
                minWidth="222px"
                display="flex"
                flexDirection="column"
                //  alignItems='center'
                gap="4px"
                backgroundColor={theme.col_4}
                height="272px"
                borderRadius="20px"
                cursor="pointer"
                sx={{ "&:hover": { boxShadow: "0px 0px 8px 0px #dfc7c7" } }}
                // boxShadow="rgba(149, 157, 165, 0.2) 0px 8px 24px"
                border={`1px solid ${theme.col_2_alpha}`}
                overflow="hidden"
                alignItems="center"
              >
                <Box
                  width="100%"
                  // px={3}
                  padding="0px 24px 0px 13px"
                  height="60px"
                  display="flex"
                  alignItems="center"
                  gap={"12px"}
                  backgroundColor={theme.col_2_alpha2}
                >
                  <AssessmentIcon
                    sx={{ color: theme.col_2, fontSize: "34px" }}
                  />
                  <Typography
                    flex="1"
                    //  borderRadius='45px'
                    color={theme.col_2}
                    fontSize={font.size.fs_5}
                  >
                    Licence Details
                  </Typography>
                  <ButtonCustom
                    borderRadius={"45px"}
                    width={"110px"}
                    height="35px"
                    // fullWidth={true}
                    typography={
                      <Typography
                        fontFamily={font.family.fm_2}
                        textTransform={"capitalize"}
                        fontSize={font.size.fs_4}
                        fontWeight="bold"
                        color={theme.col_2}
                      >
                        View Audit
                      </Typography>
                    }
                    onClick={() => setTableView(2)}
                    background={theme.col_2_alpha}
                    backgroundRipple={theme.col_2_alpha}
                  />
                  <ButtonCustom
                    borderRadius={"45px"}
                    width={"83px"}
                    height="35px"
                    // fullWidth={true}
                    typography={
                      <Typography
                        fontFamily={font.family.fm_2}
                        textTransform={"capitalize"}
                        fontSize={font.size.fs_4}
                        fontWeight="bold"
                        color={theme.col_2}
                      >
                        View all
                      </Typography>
                    }
                    onClick={() => handleAccord("Employees")}
                    background={theme.col_2_alpha}
                    backgroundRipple={theme.col_2_alpha}
                  />
                </Box>
                <Box display="flex" width="95%">
                  {licenceDetails.map((data, i) => {
                    return (
                      <>
                        <Box
                          //  flex="1"

                          minWidth="122px"
                          display="flex"
                          flexDirection="column"
                          padding="12px"
                        >
                          <Typography
                            fontWeight={"bold"}
                            color={theme.col_3}
                            fontSize={font.size.fs_6}
                          >
                            {data.label}
                          </Typography>
                          <Typography
                            color={theme.col_3}
                            fontSize={font.size.fs_2}
                          >
                            {data.count}
                          </Typography>
                        </Box>
                      </>
                    );
                  })}
                </Box>
                <Box
                  width="100%"
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  flex="1"
                  paddingLeft="22px"
                  gap="12px"
                >
                  <Typography
                    fontFamily={font.family.fm_2}
                    textTransform={"capitalize"}
                    fontSize={font.size.fs_3}
                    onClick={() => handleAccord("Trial")}
                    fontWeight="bold"
                    width="fit-content"
                    color={theme.col_3}
                    sx={{
                      "&:hover": {
                        textDecoration: "underline",
                        cursor: "pointer",
                      },
                      opacity: dayjs().isAfter(
                        licenceBatchList[0]
                          ?.expirationDate
                      ) && 0.5,
                      pointerEvents: dayjs().isAfter(
                        licenceBatchList[0]
                          ?.expirationDate
                      ) && 'none'
                    }}
                  >
                    Trial View
                  </Typography>
                  <Typography
                    fontFamily={font.family.fm_2}
                    textTransform={"capitalize"}
                    fontSize={font.size.fs_3}
                    onClick={() => handleAccord("Standard")}
                    fontWeight="bold"
                    width="fit-content"
                    color={theme.col_3}
                    sx={{
                      "&:hover": {
                        textDecoration: "underline",
                        cursor: "pointer",
                      },
                      pointerEvents:
                        licenceBatchList?.length === 1 || dayjs().isAfter(
                          licenceBatchList[licenceBatchList?.length - 1]
                            ?.expirationDate
                        ) ? "none" : "all",
                      opacity: licenceBatchList?.length === 1 || dayjs().isAfter(
                        licenceBatchList[licenceBatchList?.length - 1]
                          ?.expirationDate
                      ) ? 0.5 : 1,
                    }}
                  >
                    Standard View
                  </Typography>
                </Box>
              </Box>
              <Box
                flex="1"
                minWidth="222px"
                // maxWidth: 400,
                backgroundColor={theme.col_4}
                height="272px"
                borderRadius="20px"
                cursor="pointer"
                // border: isCurrentFilter
                //   ? `4px solid ${theme.col_2_alpha}`
                //   : `4px solid transparent`,
                overflow="hidden"
                sx={{ "&:hover": { boxShadow: "0px 0px 8px 0px #dfc7c7" } }}
                border={`1px solid ${theme.col_2_alpha}`}

                // padding="12px"
              >
                <Box
                  width="100%"
                  // px={3}
                  padding="0px 24px 0px 13px"
                  height="60px"
                  display="flex"
                  alignItems="center"
                  gap={"12px"}
                  backgroundColor={theme.col_2_alpha2}
                >
                  <PaymentIcon sx={{ color: theme.col_2, fontSize: "34px" }} />

                  <Typography
                    flex="1"
                    //  borderRadius='45px'
                    color={theme.col_2}
                    fontSize={font.size.fs_5}
                  >
                    Billing Details
                  </Typography>
                  <ButtonCustom
                    borderRadius={"45px"}
                    width={"140px"}
                    height="35px"
                    // fullWidth={true}
                    typography={
                      <Typography
                        fontFamily={font.family.fm_2}
                        textTransform={"capitalize"}
                        fontSize={font.size.fs_4}
                        fontWeight="bold"
                        color={theme.col_2}
                      >
                        View all Payments
                      </Typography>
                    }
                    onClick={() => {
                      setHeader("Payment Details");
                      setTableView(3);
                    }}
                    background={theme.col_2_alpha}
                    backgroundRipple={theme.col_2_alpha}
                  />
                </Box>
                <Box
                  width="100%"
                  px={3}
                  py={2}
                  display="flex"
                  // flexDirection="column"
                  // alignItems="center"
                  gap={"20px"}
                >
                  <Typography
                    fontWeight={"bold"}
                    color={theme.col_3}
                    fontSize={font.size.fs_6}
                    display="flex"
                    flexDirection="column"
                    // gap='5px'
                  >
                    Total Payment{" "}
                    <Typography
                      // fontWeight={"bold"}
                      color={theme.col_3}
                      fontSize={font.size.fs_2}
                    >
                      &pound;
                      {Math.round(paymentList
                        ?.slice(1)
                        ?.map((data) => parseFloat(data?.paidAmount))
                        ?.reduce((a, b) => a + b, 0))}
                    </Typography>
                  </Typography>
                  <Typography
                    fontWeight={"bold"}
                    color={theme.col_3}
                    fontSize={font.size.fs_6}
                    display="flex"
                    flexDirection="column"
                    // gap='5px'
                  >
                    Last Payment{" "}
                    <Typography
                      // fontWeight={"bold"}
                      color={theme.col_3}
                      fontSize={font.size.fs_2}
                    >
                      &pound;
                      {paymentList?.length < 2
                        ? "0"
                        : Math.round(paymentList[paymentList?.length - 1]?.paidAmount)}
                    </Typography>
                  </Typography>
                </Box>
              </Box>

              {/* <DashboardCard
            title={"Total Licence"}
            count={licenceBatchList
              ?.map((data) => data?.totalLicenses)
              .reduce((a, b) => a + b, 0)}
            type={cardFilter.all}
            currentLicenceFilter={currentLicenceFilter}
            setCurrentLicenceFilter={setCurrentLicenceFilter}
            isCurrentFilter={currentLicenceFilter === ""}
          /> */}

              {/* <DashboardCard
            title={"Allocated"}
            count={licenceBatchList
              ?.map((data) => data?.allocatedLicenses)
              .reduce((a, b) => a + b, 0)}
            type={cardFilter.allocated}
            currentLicenceFilter={currentLicenceFilter}
            setCurrentLicenceFilter={setCurrentLicenceFilter}
            isCurrentFilter={currentLicenceFilter === "allocated"}
          />

          <DashboardCard
            title={"Unallocated"}
            count={
              licenceBatchList
                ?.map((data) => data?.totalLicenses)
                .reduce((a, b) => a + b, 0) -
              licenceBatchList
                ?.map((data) => data?.allocatedLicenses)
                .reduce((a, b) => a + b, 0)
            }
            type={cardFilter.unallocated}
            currentLicenceFilter={currentLicenceFilter}
            setCurrentLicenceFilter={setCurrentLicenceFilter}
            isCurrentFilter={currentLicenceFilter === "unallocated"}
          /> */}
            </Box>
            <Box display="flex" width="100%" flexWrap="wrap" gap="24px">
              <Box
                flex="1"
                minWidth="222px"
                display="flex"
                flexDirection="column"
                //  alignItems='center'
                gap="4px"
                backgroundColor={theme.col_4}
                height="272px"
                borderRadius="20px"
                cursor="pointer"
                sx={{
                  "&:hover": { boxShadow: "0px 0px 8px 0px #dfc7c7" },
                  pointerEvents: dayjs().isAfter(
                    licenceBatchList[0]?.expirationDate
                  )
                    ? "none"
                    : "all",
                  opacity: dayjs().isAfter(licenceBatchList[0]?.expirationDate)
                    ? "0.5"
                    : "1",
                }}
                border={`1px solid ${theme.col_2_alpha}`}
                overflow="hidden"
                alignItems="center"
                position="relative"
                justifyContent="center"
              >
                {finalDateDemo <= 5 ? (
                  <Typography
                    padding={"4px 7px 4px 7px"}
                    position="absolute"
                    right="0px"
                    // top="12px"
                    borderRadius="42px 0px 0px 42px"
                    backgroundColor={theme.col_15_alpha}
                    color={theme.col_15}
                    fontSize={font.size.fs_3}
                  >
                    {finalDateDemo < 1
                      ? "Expired"
                      : `Expire in ${finalDateDemo} ${
                          finalDateDemo < 2 ? "day" : "days"
                        }`}
                  </Typography>
                ) : (
                  <></>
                )}
                <Box
                  width="100%"
                  // px={3}
                  height="60px"
                  display="flex"
                  alignItems="center"
                  gap={"12px"}
                  padding="0px 24px 0px 9px"
                  backgroundColor={theme.col_2_alpha2}
                >
                  <LicenseIcon activeTab={2} />
                  <Typography
                    flex="1"
                    //  borderRadius='45px'
                    color={theme.col_2}
                    fontSize={font.size.fs_5}
                  >
                    Trial
                  </Typography>
                  {admin ?  <></>: <ButtonCustom
                    borderRadius={"45px"}
                    // width={"83px"}
                    height="35px"
                    width="120px"
                    // fullWidth={true}
                    typography={
                      <Typography
                        fontFamily={font.family.fm_2}
                        textTransform={"capitalize"}
                        fontSize={font.size.fs_4}
                        fontWeight="bold"
                        color={theme.col_2}
                      >
                        Add employee
                      </Typography>
                    }
                    // onClick={() => setActiveTab(i)}
                    onClick={() => {
                      setLicenceType("Trial");
                      setIsOpenRegisterEmployeeDialog(true);
                    }}
                    background={theme.col_2_alpha}
                    backgroundRipple={theme.col_2_alpha}
                  />}
                  <ButtonCustom
                    borderRadius={"45px"}
                    width={"83px"}
                    height="35px"
                    minWidth="83px"
                    // fullWidth={true}
                    typography={
                      <Typography
                        fontFamily={font.family.fm_2}
                        textTransform={"capitalize"}
                        fontSize={font.size.fs_4}
                        fontWeight="bold"
                        color={theme.col_2}
                      >
                        View all
                      </Typography>
                    }
                    onClick={() => handleAccord("Trial")}


                    background={theme.col_2_alpha}
                    backgroundRipple={theme.col_2_alpha}
                  />
                </Box>
                <Box display="flex" width="95%">
                  {Array.of(
                    {
                      label: "Total Licence",
                      count: licenceBatchList[0]?.totalLicenses,
                    },
                    {
                      label: "Allocated Licence",
                      count: licenceBatchList[0]?.allocatedLicenses ?? 0,
                    },
                    {
                      label: "Unallocated Licence",
                      count: Number.isNaN(
                        licenceBatchList[0]?.totalLicenses -
                          licenceBatchList[0]?.allocatedLicenses
                      )
                        ? 0
                        : licenceBatchList[0]?.totalLicenses -
                          licenceBatchList[0]?.allocatedLicenses,
                    }
                  ).map((data, i) => {
                    return (
                      <>
                        <Box
                          //  flex="1"

                          minWidth="122px"
                          display="flex"
                          flexDirection="column"
                          padding="12px"
                        >
                          <Typography
                            fontWeight={"bold"}
                            color={theme.col_3}
                            fontSize={font.size.fs_6}
                          >
                            {data.label}
                          </Typography>
                          <Typography
                            color={theme.col_3}
                            fontSize={font.size.fs_2}
                          >
                            {data.count}
                          </Typography>
                        </Box>
                      </>
                    );
                  })}
                  {/* <Box
           flex="1"
          // width='33%'
           minWidth= "122px"
           display='flex'
           flexDirection='column'
          //  justifyContent={'center'}
          //  alignItems={'center'}
           // maxWidth: 400,

          // border={`2px solid ${theme.col_3_alpha}`}
           // border: isCurrentFilter
           //   ? `4px solid ${theme.col_2_alpha}`
           //   : `4px solid transparent`,
          //  boxShadow= "rgba(149, 157, 165, 0.2) 0px 8px 24px"
           padding='12px'
         >
 <Typography
              color={theme.col_2}
              fontSize={font.size.fs_3}
            >
              Trial Licence
            </Typography>
            <Typography
              color={theme.col_2}
              fontSize={font.size.fs_2}
            >
              100
            </Typography>

         </Box>
         <Box
           flex="1"
          // width='33%'
           minWidth= "122px"
           display='flex'
           flexDirection='column'
          //  justifyContent={'center'}
          //  alignItems={'center'}
           // maxWidth: 400,

          // border={`2px solid ${theme.col_3_alpha}`}
           // border: isCurrentFilter
           //   ? `4px solid ${theme.col_2_alpha}`
           //   : `4px solid transparent`,
          //  boxShadow= "rgba(149, 157, 165, 0.2) 0px 8px 24px"
           padding='12px'
         >
 <Typography
              color={theme.col_2}
              fontSize={font.size.fs_3}
            >
              Standard Licence
            </Typography>
            <Typography
              color={theme.col_2}
              fontSize={font.size.fs_2}
            >
              100
            </Typography>

         </Box> */}
                </Box>
                <Box
                  display="flex"
                  flexDirection="row"
                  gap="8px"
                  flex="1"
                  width="95%"
                  alignItems="center"
                  pr={3}
                  // justifyContent="center"
                >
                  <Box
                    display="flex"
                    // alignItems="center"
                    flexDirection="column"
                    gap={1}
                    borderRadius="20px"
                    py={0.4}
                    px={2}
                    flex="1"
                    // bgcolor={theme.col_3}
                    justifyContent="center"
                  >
                    <Typography
                      color={theme.col_3}
                      variant="body2"
                      component="div"
                      fontWeight="bold"
                    >
                      Licence Validity
                    </Typography>
                    <Typography
                      color={theme.col_3}
                      variant="body2"
                      component="b"
                      display="flex"
                      gap="5px"
                    >
                      {/* 24 January 2024 */}
                      {dayjs(licenceBatchList[0]?.purchaseDate).format(
                        "DD MMMM YYYY"
                      )}{" "}
                      to{" "}
                      <Typography
                        color={theme.col_2}
                        variant="body2"
                        component="b"
                      >
                        {dayjs(licenceBatchList[0]?.expirationDate).format(
                          "DD MMMM YYYY"
                        )}
                      </Typography>
                      {/* {dayjs()} */}
                      {/* {plans.validity} */}
                      {/* 28 December 2023 */}
                      {/* {dayjs(expirationDate).format("DD MMMM YYYY")} */}
                      {/* {dayjs(plans?.purchaseDate).format("DD MMMM YYYY")} */}
                    </Typography>
                  </Box>

                  {/* <Box
                    display="flex"
                    alignItems="center"
                    gap={1}
                    borderRadius="20px"
                    py={0.4}
                    px={2}
                    justifyContent="center"
                  >
                    <Typography
                      color={theme.col_2}
                      variant="body2"
                      component="div"
                    >
                      Valid up to:
                    </Typography>
                    <Typography
                      color={theme.col_2}
                      variant="body2"
                      component="b"
                    >
                      {dayjs(licenceBatchList[0]?.expirationDate).format(
                        "DD MMMM YYYY"
                      )}

                    </Typography>
                  </Box> */}
                  {!admin ? (
                    <></>
                  ) : (
                    <ButtonCustom
                      borderRadius={"45px"}
                      // width={"83px"}
                      height="35px"
                      minWidth="83px"
                      // fullWidth={true}
                      typography={
                        <Typography
                          fontFamily={font.family.fm_2}
                          textTransform={"capitalize"}
                          fontSize={font.size.fs_4}
                          fontWeight="bold"
                          color={theme.col_1}
                        >
                          Extend Trial
                        </Typography>
                      }
                      onClick={() => handleLicenceModal(detailsDialog,true)}
                      background={theme.col_16}
                      backgroundRipple={theme.col_16}
                    />
                  )}
                </Box>
              </Box>
              <Box
                flex="1"
                minWidth="222px"
                display="flex"
                flexDirection="column"
                //  alignItems='center'
                gap="4px"
                backgroundColor={theme.col_4}
                height="272px"
                borderRadius="20px"
                cursor="pointer"
                sx={{
                  "&:hover": { boxShadow: "0px 0px 8px 0px #dfc7c7" },
                  pointerEvents:
                    licenceBatchList.length < 2 ||
                    dayjs().isAfter(
                      licenceBatchList[licenceBatchList?.length - 1]
                        ?.expirationDate
                    )
                      ? "none"
                      : "all",
                  opacity:
                    licenceBatchList.length < 2 ||
                    dayjs().isAfter(
                      licenceBatchList[licenceBatchList?.length - 1]
                        ?.expirationDate
                    )
                      ? "0.5"
                      : "1",
                }}
                border={`1px solid ${theme.col_2_alpha}`}
                overflow="hidden"
                alignItems="center"
                justifyContent="center"
              >
                {finalDateStandard <= 5 && licenceBatchList.length > 1 ? (
                  <Typography
                    padding={"4px 7px 4px 7px"}
                    position="absolute"
                    right="0px"
                    // top="12px"
                    borderRadius="42px 0px 0px 42px"
                    backgroundColor={theme.col_15_alpha}
                    color={theme.col_15}
                    fontSize={font.size.fs_3}
                  >
                    {finalDateStandard < 1
                      ? "Expired"
                      : `Expire in ${finalDateStandard} ${
                          finalDateStandard < 2 ? "day" : "days"
                        }`}
                  </Typography>
                ) : (
                  <></>
                )}
                <Box
                  width="100%"
                  // px={3}
                  padding="0px 24px 0px 9px"
                  height="60px"
                  display="flex"
                  alignItems="center"
                  gap={"12px"}
                  backgroundColor={theme.col_2_alpha2}
                >
                  <LicenseIcon activeTab={2} />

                  <Typography
                    flex="1"
                    //  borderRadius='45px'
                    color={theme.col_2}
                    fontSize={font.size.fs_5}
                  >
                    Standard
                  </Typography>
                {admin ? <></> :  <ButtonCustom
                    borderRadius={"45px"}
                    // width={"83px"}
                    height="35px"
                    width="120px"
                    minWidth="120px"
                    // fullWidth={true}
                    typography={
                      <Typography
                        fontFamily={font.family.fm_2}
                        textTransform={"capitalize"}
                        fontSize={font.size.fs_4}
                        fontWeight="bold"
                        color={theme.col_2}
                      >
                        Add employee
                      </Typography>
                    }
                    // onClick={() => setActiveTab(i)}
                    onClick={() => {
                      setLicenceType("standard");
                      setIsOpenRegisterEmployeeDialog(true);
                    }}
                    background={theme.col_2_alpha}
                    backgroundRipple={theme.col_2_alpha}
                  />}
                  <ButtonCustom
                    borderRadius={"45px"}
                    width={"83px"}
                    height="35px"
                    minWidth="83px"
                    // fullWidth={true}
                    typography={
                      <Typography
                        fontFamily={font.family.fm_2}
                        textTransform={"capitalize"}
                        fontSize={font.size.fs_4}
                        fontWeight="bold"
                        color={theme.col_2}
                      >
                        View all
                      </Typography>
                    }
                    onClick={() => handleAccord("Standard")}
                    background={theme.col_2_alpha}
                    backgroundRipple={theme.col_2_alpha}
                  />
                </Box>
                <Box display="flex" width="95%" flex="1">
                  {Array.of(
                    {
                      label: "Total Licence",
                      count:
                        licenceBatchList
                          ?.slice(1)
                          ?.map((data) => data?.totalLicenses)
                          ?.reduce((a, b) => a + b, 0) ?? 0,
                    },
                    {
                      label: "Allocated Licence",
                      count:
                        licenceBatchList
                          ?.slice(1)
                          ?.map((data) => data?.allocatedLicenses)
                          ?.reduce((a, b) => a + b, 0) ?? 0,
                    },
                    {
                      label: "Unallocated Licence",
                      count:
                        licenceBatchList
                          ?.slice(1)
                          ?.map((data) => data?.totalLicenses)
                          ?.reduce((a, b) => a + b, 0) -
                          licenceBatchList
                            ?.slice(1)
                            ?.map((data) => data?.allocatedLicenses)
                            ?.reduce((a, b) => a + b, 0) ?? 0,
                    }
                  ).map((data, i) => {
                    return (
                      <>
                        <Box
                          //  flex="1"

                          minWidth="122px"
                          display="flex"
                          flexDirection="column"
                          padding="12px"
                        >
                          <Typography
                            fontWeight={"bold"}
                            color={theme.col_3}
                            fontSize={font.size.fs_6}
                          >
                            {data.label}
                          </Typography>
                          <Typography
                            color={theme.col_3}
                            fontSize={font.size.fs_2}
                          >
                            {data.count}
                          </Typography>
                        </Box>
                      </>
                    );
                  })}
                  {/* <Box
           flex="1"
          // width='33%'
           minWidth= "122px"
           display='flex'
           flexDirection='column'
          //  justifyContent={'center'}
          //  alignItems={'center'}
           // maxWidth: 400,

          // border={`2px solid ${theme.col_3_alpha}`}
           // border: isCurrentFilter
           //   ? `4px solid ${theme.col_2_alpha}`
           //   : `4px solid transparent`,
          //  boxShadow= "rgba(149, 157, 165, 0.2) 0px 8px 24px"
           padding='12px'
         >
 <Typography
              color={theme.col_2}
              fontSize={font.size.fs_3}
            >
              Trial Licence
            </Typography>
            <Typography
              color={theme.col_2}
              fontSize={font.size.fs_2}
            >
              100
            </Typography>

         </Box>
         <Box
           flex="1"
          // width='33%'
           minWidth= "122px"
           display='flex'
           flexDirection='column'
          //  justifyContent={'center'}
          //  alignItems={'center'}
           // maxWidth: 400,

          // border={`2px solid ${theme.col_3_alpha}`}
           // border: isCurrentFilter
           //   ? `4px solid ${theme.col_2_alpha}`
           //   : `4px solid transparent`,
          //  boxShadow= "rgba(149, 157, 165, 0.2) 0px 8px 24px"
           padding='12px'
         >
 <Typography
              color={theme.col_2}
              fontSize={font.size.fs_3}
            >
              Standard Licence
            </Typography>
            <Typography
              color={theme.col_2}
              fontSize={font.size.fs_2}
            >
              100
            </Typography>

         </Box> */}
                </Box>
                {licenceBatchList.length < 2 ? (
                  <></>
                ) : (
                  <Box
                    display="flex"
                    // flexDirection="column"
                    gap="14px"
                    flex="1"
                    width="95%"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Box
                      display="flex"
                      flexDirection="column"
                      gap="8px"
                      flex="1"
                      width="95%"
                      alignItems="flex-start  "
                      justifyContent="center"
                    >
                      <Box
                        display="flex"
                        // alignItems="center"
                        flexDirection="column"
                        gap={1}
                        borderRadius="20px"
                        py={0.4}
                        px={2}
                        // bgcolor={theme.col_3}
                        justifyContent="center"
                      >
                        <Typography
                          color={theme.col_3}
                          variant="body2"
                          component="div"
                          fontWeight="bold"
                        >
                          Licence Validity
                        </Typography>
                        <Typography
                          color={theme.col_3}
                          variant="body2"
                          component="b"
                          display="flex"
                          gap="5px"
                        >
                          {/* 24 January 2024 */}
                          {/* {dayjs()} */}
                          {/* {plans.validity} */}
                          {/* 28 December 2023 */}
                          {/* {dayjs(expirationDate).format("DD MMMM YYYY")} */}
                          {dayjs(licenceBatchList[1]?.purchaseDate).format(
                            "DD MMMM YYYY"
                          )}{" "}
                          to{" "}
                          <Typography
                            color={theme.col_2}
                            variant="body2"
                            component="b"
                          >
                            {dayjs(licenceBatchList[1]?.expirationDate).format(
                              "DD MMMM YYYY"
                            )}
                          </Typography>
                        </Typography>
                      </Box>
                      {/* <Box
                        display="flex"
                        alignItems="center"
                        gap={1}
                        borderRadius="20px"
                        py={0.4}
                        px={2}
                        justifyContent="center"
                      >
                        <Typography
                          color={theme.col_2}
                          variant="body2"
                          component="div"
                        >
                          Valid up to:
                        </Typography>
                        <Typography
                          color={theme.col_2}
                          variant="body2"
                          component="b"
                        >
                          {dayjs(licenceBatchList[1]?.expirationDate).format(
                            "DD MMMM YYYY"
                          )}
                        </Typography>
                      </Box> */}
                    </Box>

                    {!admin ? (
                      <></>
                    ) : (
                      <Box display='flex' flexDirection='column'  gap='8px' pr={3}>
                         <Typography
                            fontFamily={font.family.fm_2}
                            textTransform={"capitalize"}
                            fontSize={font.size.fs_3}
                            fontWeight="bold"
                            color={theme.col_16}
                          >
                            Current Discount: {detailsDialog?.discount}% 
                          </Typography>
                      <ButtonCustom
                        borderRadius={"45px"}
                        // width={"83px"}
                        height="35px"
                        minWidth="83px"
                        // fullWidth={true}
                        typography={
                          <Typography
                            fontFamily={font.family.fm_2}
                            textTransform={"capitalize"}
                            fontSize={font.size.fs_4}
                            fontWeight="bold"
                            color={theme.col_1}
                          >
                            Apply Discount 
                          </Typography>
                        }
                        onClick={() => handleDiscountModal(detailsDialog)}
                        background={theme.col_16}
                        backgroundRipple={theme.col_16}
                      />
                    </Box>
                    )}
                  </Box>
                )}
              </Box>

              {/* <DashboardCard
            title={"Total Licence"}
            count={licenceBatchList
              ?.map((data) => data?.totalLicenses)
              .reduce((a, b) => a + b, 0)}
            type={cardFilter.all}
            currentLicenceFilter={currentLicenceFilter}
            setCurrentLicenceFilter={setCurrentLicenceFilter}
            isCurrentFilter={currentLicenceFilter === ""}
          /> */}

              {/* <DashboardCard
            title={"Allocated"}
            count={licenceBatchList
              ?.map((data) => data?.allocatedLicenses)
              .reduce((a, b) => a + b, 0)}
            type={cardFilter.allocated}
            currentLicenceFilter={currentLicenceFilter}
            setCurrentLicenceFilter={setCurrentLicenceFilter}
            isCurrentFilter={currentLicenceFilter === "allocated"}
          />

          <DashboardCard
            title={"Unallocated"}
            count={
              licenceBatchList
                ?.map((data) => data?.totalLicenses)
                .reduce((a, b) => a + b, 0) -
              licenceBatchList
                ?.map((data) => data?.allocatedLicenses)
                .reduce((a, b) => a + b, 0)
            }
            type={cardFilter.unallocated}
            currentLicenceFilter={currentLicenceFilter}
            setCurrentLicenceFilter={setCurrentLicenceFilter}
            isCurrentFilter={currentLicenceFilter === "unallocated"}
          /> */}
            </Box>
          </>
        )}
        {/* <Box
          display="flex"
          gap={4}
          width="100%"
          flexDirection="column"
          // height="100%"
          flex="1"
          borderRadius="8px"
        >
           

        
          <Box
            // display="flex"
            // gap={4}
            // width="100%"
            // height="100%"
            // borderRadius="8px"
            // flexWrap="wrap"

            display="flex"
            width="100%"
            // height="100%"
            // border="2px solid blue"
          >
            <Typography
              color={theme.col_3}
              fontSize={font.size.fs_2}
              component="div"
            >
              Your Plans
            </Typography>
          </Box>
          <Box
            // display="flex"
            // gap={4}
            // width="100%"
            // height="100%"
            // borderRadius="8px"
            // flexWrap="wrap"

            display="flex"
            width="100%"
            // height="100%"
            // alignItems='center'
            // justifyContent='center'
            flexWrap="wrap"
            gap="14px"
            flex="1"
            // border="2px solid blue"
          >
            {licenceBatchList.length === 0 ? (
              <Box
                // display="flex"
                // gap={4}
                // width="100%"
                // height="100%"
                // borderRadius="8px"
                // flexWrap="wrap"

                display="flex"
                width="100%"
                // height="100%"
                alignItems="center"
                justifyContent="center"
                flexWrap="wrap"
                flex="1"
                // border="2px solid blue"
              >
                <NoDataFound message={"No Licence Found"} />
              </Box>
            ) : (
              licenceBatchList?.map((plans, i) => (
                <PlanCard
                  licenceBatchList={licenceBatchList}
                  plans={plans}
                  profileQuery={profileQuery}
                  profileDetails={profileDetails}
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                />
              ))
            )}
          </Box>
        </Box> */}
      </Box>
      {tableView === 0 ? (
        <RegisterEmployeeDialog
          onBoardSnack={profileSnack}
          setOnBoardSnack={setProfileSnack}
          error={error}
          setError={setError}
        />
      ) : (
        <></>
      )}
      <GlobalSnackBar
        open={profileSnack}
        title={error}
        close={setProfileSnack}
      />
    </>
  );
};

const DashBoardNav = ({ setTableView, tableView }) => {
  switch (tableView) {
    case 1:
      return <UserProfile setTableView={setTableView} tableView={tableView} />;
    case 2:
      return <Audit setTableView={setTableView} tableView={tableView} />;
    case 3:
      return (
        <PaymentDetails setTableView={setTableView} tableView={tableView} />
      );
    default:
      return;
  }
};

// const DashboardCard = ({
//   title,
//   count,
// }) => {
//   return (
//     <Card
//       sx={{
//         width: "100%",
//         flex: 1,
//         minWidth: "222px",
//         // maxWidth: 400,
//         height: "122px",
//         borderRadius: "20px",
//         cursor: "pointer",
//         // border: isCurrentFilter
//         //   ? `4px solid ${theme.col_2_alpha}`
//         //   : `4px solid transparent`,
//         boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
//       }}
//       // onClick={() => setCurrentLicenceFilter(type)}
//     >
//       {/* <CardContent sx={{ pb: 0 }}> */}
//       <Box display="flex" flexDirection="column" gap={1} m={2}>
//         <Box
//           display="flex"
//           justifyContent="flex-start"
//           gap={2}
//           flexWrap="wrap"
//           height="100%"
//         >
//           <Box
//             display="flex"
//             alignItems="center"
//             justifyContent="center"
//             py={1}
//             minHeight="100%"
//           >
//             <VerifiedUser sx={{ fontSize: 60, color: theme.col_3 }} />
//           </Box>

//           <Box
//             display="flex"
//             flexDirection="column"
//             alignItems="flex-start"
//             flex={1}
//             height="100%"
//           >
//             <Typography color={theme.col_2} fontSize="18px" gutterBottom>
//               {title}
//             </Typography>
//             <Typography color={theme.col_6} fontSize="32px" component="div">
//               {count}
//             </Typography>
//           </Box>
//         </Box>

//         {/* <Box display="flex" flexDirection="column" gap={2} height="100%">
//         <Box display="flex" alignItems="center" >
//           <Typography color={theme.col_2} variant="h5" gutterBottom>
//             {title}
//           </Typography>
//         </Box>

//         <Box display="flex" alignItems="center" flexWrap="wrap" height="100%" >

//           <VerifiedUser sx={{ fontSize: 60, color: theme.col_3 }} />
//           <Typography color={theme.col_6} variant="h4" component="div" flex={1}>
//             {count}
//           </Typography>
//         </Box>
//       </Box> */}
//       </Box>
//       {/* </CardContent> */}
//     </Card>
//   );
// };

// const PlanCard = ({
//   profileDetails,
//   activeTab,
//   setActiveTab,
//   profileQuery,
//   plans,
//   licenceBatchList,
// }) => {
//   const expirationDate = dayjs().isAfter(plans.expirationDate);
//   // console.log(expirationDate, "date")

//   return (
//     <Box
//       width="32%"
//       flex={profileQuery ? "1" : "none"}
//       minWidth="286px"
//       flexDirection="column"
//       display="flex"
//       // maxWidth: 400,
//       height="220px"
//       alignItems="center"
//       justifyContent="center"
//       position="relative"
//       overflow="auto"
//       borderRadius="8px"
//       backgroundColor={expirationDate ? theme.col_1 : theme.col_4}
//       boxShadow="rgba(149, 157, 165, 0.2) 0px 8px 24px"
//     >
//       {expirationDate ? (
//         <Typography
//           padding={"4px 7px 4px 7px"}
//           position="absolute"
//           right="12px"
//           top="12px"
//           borderRadius="42px"
//           backgroundColor={theme.col_2_alpha}
//           color={theme.col_2}
//           fontSize={font.size.fs_3}
//         >
//           Expired
//         </Typography>
//       ) : (
//         <></>
//       )}
//       {/* <CardContent>
//       <Typography color={theme.col_2} variant="h5" gutterBottom>
//         {title}
//       </Typography>
//       <Typography color={theme.col_3} variant="h2" component="div">
//         {mainHeading}
//       </Typography>
//       <Box display="flex" alignItems="center" gap={2}>
//         <Chip label="Active" sx={{ background: theme.statusSuccessAlpha, color: theme.statusSuccess, fontWeight: "bold" }} />
//         <Box display="flex" flexDirection="column" >
//           <Typography color={theme.col_6} variant="body2" component="div">
//             next renew on
//           </Typography>
//           <Typography color={theme.col_3} variant="body2" component="b">
//             24 January 2024
//           </Typography>
//         </Box>
//       </Box>
//     </CardContent> */}
//       {/* <CardContent style={{ position: "relative", p: 1 }}> */}

//       {/* <Box bgcolor={theme.col_2} borderRadius="20px" py={0.4} px={1} position="absolute" top={"-20px"} left={"20px"} zIndex={10}>
//       <Typography color={theme.col_4} fontSize="18px" >
//         {title}
//       </Typography>

//     </Box> */}

//       <Box
//         display="flex"
//         flexDirection="column"
//         justifyContent="center"
//         gap={2}
//       >
//         <Box
//           display="flex"
//           flex="1"
//           flexDirection="column"
//           alignItems="center"
//           justifyContent="center"
//           gap={0.3}
//         >
//           <Typography
//             color={theme.col_3}
//             fontSize={font.size.fs_2}
//             component="div"
//           >
//             {plans?.isDemo
//               ? "Trial"
//               : !plans.isDemo && licenceBatchList.length === 1
//               ? "Trial"
//               : "Standard"}
//             {/* {plans.label} */}
//           </Typography>
//           <Typography
//             color={theme.col_2}
//             fontSize={font.size.fs_3}
//             component="div"
//           >
//             Total Licence : {plans?.totalLicenses}
//           </Typography>
//           <Typography
//             color={theme.col_2}
//             fontSize={font.size.fs_3}
//             component="div"
//           >
//             Allocated Licence : {plans?.allocatedLicenses}
//           </Typography>
//           {/* <Chip label="Active" sx={{ background: theme.statusSuccessAlpha, color: theme.statusSuccess, fontWeight: "bold" }} /> */}
//         </Box>

//         <Box
//           display="flex"
//           justifyContent="center"
//           flexDirection="column"
//           gap={2}
//         >
//           {/* <Chip label="Active" sx={{ background: theme.statusSuccessAlpha, color: theme.statusSuccess, fontWeight: "bold" }} /> */}
//           <Box
//             display="flex"
//             alignItems="center"
//             gap={1}
//             borderRadius="20px"
//             py={0.4}
//             px={2}
//             bgcolor={theme.col_3}
//             justifyContent="center"
//           >
//             <Typography color={theme.col_4} variant="body2" component="div">
//               Purchased on:
//             </Typography>
//             <Typography color={theme.col_4} variant="body2" component="b">
//               {/* 24 January 2024 */}
//               {/* {dayjs()} */}
//               {/* {plans.validity} */}
//               {/* 28 December 2023 */}
//               {/* {dayjs(expirationDate).format("DD MMMM YYYY")} */}
//               {dayjs(plans?.purchaseDate).format("DD MMMM YYYY")}
//             </Typography>
//           </Box>
//           <Box
//             display="flex"
//             alignItems="center"
//             gap={1}
//             borderRadius="20px"
//             py={0.4}
//             px={2}
//             bgcolor={theme.col_2}
//             justifyContent="center"
//           >
//             <Typography color={theme.col_4} variant="body2" component="div">
//               Valid upto:
//             </Typography>
//             <Typography color={theme.col_4} variant="body2" component="b">
//               {/* 24 January 2024 */}
//               {/* {dayjs()} */}
//               {/* {plans.validity} */}
//               {dayjs(plans?.expirationDate).format("DD MMMM YYYY")}
//             </Typography>
//           </Box>
//         </Box>
//       </Box>
//       {/* </CardContent> */}
//     </Box>
//   );
// };
